"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var _default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

exports.default = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/utils/ponyfillGlobal.js
 ** module id = 447
 ** module chunks = 0
 **/